export class EngineStatus {
    constructor(es?: EngineStatus | null) {
        this.running = es?.running ?? false;
    }

    public running: boolean = false;
}